import { Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, blackTransparent, whiteTransparent } from 'utils/colors';
import {
    heightPercentageToDP,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    programCell: {
        flex: 1,
        borderRadius: 4,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        overflow: 'hidden',
        marginBottom: 8,
    },
    programCellLive: {
        backgroundColor: whiteTransparent(0.2),
    },
    programCellText: {
        paddingHorizontal: 6,
    },
    programContainer: {
        flex: 1,
        flexDirection: 'row',
    },
    contentContainer: {
        flex: 1,
        paddingHorizontal: widthPercentageToDP(8),
        paddingVertical: heightPercentageToDP(8),
    },
    unsubscribedOverlay: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: blackTransparent(0.5),
    },
    recordingIcon: {
        marginLeft: 0,
        marginRight: 4,
        width: 24,
        height: 24,
        alignSelf: 'center',
    },
    marker: {
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        left: 8,
        bottom: 8,
    },
    markerText: {
        alignSelf: 'center',
        fontFamily: Fonts.main.bold,
        fontSize: 12,
        color: COLOR.background,
    },
    isOnLiveCard: {
        bottom: Platform.select({
            web: 18,
            default: 20,
        }),
    },
    imageContainer: {
        width: widthPercentageToDP(128),
        height: heightPercentageToDP(72),
        marginRight: widthPercentageToDP(8),
    },
    titleContainer: {
        flex: 1,
    },
});

export default styles;
